import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { setLayoutChange } from "../core/redux/action";
import ImageWithBasePath from "../core/img/imagewithbasebath";

const ThemeSettings = () => {
  const dispatch = useDispatch();

  const [show, setShow] = useState(false);
  const [layoutColor, setLayoutColor] = useState(
    localStorage.getItem("colorschema") || "light_mode"
  );
  const [layoutView, setLayoutView] = useState(
    localStorage.getItem("layoutStyling") || "default"
  );
  const [layoutTheme, setLayoutTheme] = useState(
    localStorage.getItem("layoutThemeColors") || "light"
  );
  const [direction, setDirection] = useState(
    localStorage.getItem("direction") || "ltr"
  );

  const showSettings = () => {
    setShow(!show);
  };

  const DarkThemes = () => {
    localStorage.setItem("colorschema", "dark_mode");
    setLayoutColor("dark_mode");
    document.documentElement.setAttribute("data-layout-mode", "dark_mode");
  };

  const LightThemes = () => {
    localStorage.setItem("colorschema", "light_mode");
    setLayoutColor("light_mode");
    document.documentElement.setAttribute("data-layout-mode", "light_mode");
  };

  const DefaultStyle = () => {
    localStorage.setItem("layoutStyling", "default");
    setLayoutView("default");
    dispatch(setLayoutChange("default"));
    document.documentElement.setAttribute("data-layout-style", "default");
  };

  const LayoutBox = () => {
    localStorage.setItem("layoutStyling", "box");
    setLayoutView("box");
    dispatch(setLayoutChange("box"));
    document.documentElement.setAttribute("data-layout-style", "box");
  };

  const CollapsedLayout = () => {
    localStorage.setItem("layoutStyling", "collapsed");
    setLayoutView("collapsed");
    dispatch(setLayoutChange("collapsed"));
    document.documentElement.setAttribute("data-layout-style", "collapsed");
  };

  const HorizontalLayout = () => {
    localStorage.setItem("layoutStyling", "horizontal");
    setLayoutView("horizontal");
    dispatch(setLayoutChange("horizontal"));
    document.documentElement.setAttribute("data-layout-style", "horizontal");
  };

  const ModernLayout = () => {
    localStorage.setItem("layoutStyling", "modern");
    setLayoutView("modern");
    dispatch(setLayoutChange("modern"));
    document.documentElement.setAttribute("data-layout-style", "modern");
  };

  const LayoutGrey = () => {
    localStorage.setItem("layoutThemeColors", "grey");
    setLayoutTheme("grey");
    document.documentElement.setAttribute("data-nav-color", "grey");
  };

  const LayoutDark = () => {
    localStorage.setItem("layoutThemeColors", "dark");
    setLayoutTheme("dark");
    document.documentElement.setAttribute("data-nav-color", "dark");
  };

  const LayoutLight = () => {
    localStorage.setItem("layoutThemeColors", "light");
    setLayoutTheme("light");
    document.documentElement.setAttribute("data-nav-color", "light");
  };

  const LTRDirection = () => {
    localStorage.setItem("direction", "ltr");
    setDirection("ltr");
    document.documentElement.setAttribute("data-direction", "ltr");
  };

  const RTLDirection = () => {
    localStorage.setItem("direction", "rtl");
    setDirection("rtl");
    document.documentElement.setAttribute("data-direction", "rtl");
  };

  const ResetData = () => {
    localStorage.setItem("colorschema", "light_mode");
    localStorage.setItem("layoutStyling", "default");
    localStorage.setItem("layoutThemeColors", "light");
    localStorage.setItem("direction", "ltr");

    setLayoutColor("light_mode");
    setLayoutView("default");
    setLayoutTheme("light");
    setDirection("ltr");

    document.documentElement.setAttribute("data-layout-mode", "light_mode");
    document.documentElement.setAttribute("data-layout-style", "default");
    document.documentElement.setAttribute("data-nav-color", "light");
    document.documentElement.setAttribute("data-direction", "ltr");
  };

  useEffect(() => {
    document.documentElement.setAttribute("data-layout-mode", layoutColor);
    document.documentElement.setAttribute("data-layout-style", layoutView);
    document.documentElement.setAttribute("data-nav-color", layoutTheme);
    document.documentElement.setAttribute("data-direction", direction);
  }, [layoutColor, layoutView, layoutTheme, direction]);

  return (
    <div
      className={
        show
          ? "sidebar-settings nav-toggle show-settings"
          : "sidebar-settings nav-toggle"
      }
      id="layoutDiv"
    >
      <div className="sidebar-content sticky-sidebar-one">
        <div className="sidebar-header">
          <div className="sidebar-theme-title">
            <h5>Theme Customizer</h5>
            <p>Customize & Preview in Real Time</p>
          </div>
          <div className="close-sidebar-icon d-flex">
            <Link className="sidebar-refresh me-2" onClick={ResetData}>
              ⟳
            </Link>
            <Link className="sidebar-close" to="#" onClick={showSettings}>
              X
            </Link>
          </div>
        </div>
        <div className="sidebar-body p-0">
          <div id="theme_color">
            <div className="theme-mode mb-0">
              <div className="theme-head">
                <h6>Theme Mode</h6>
                <p>Enjoy Dark & Light modes.</p>
              </div>
              <div className="row">
                <div className="col-xl-6 ere">
                  <div className="layout-wrap">
                    <div className="d-flex align-items-center">
                      <div className="status-toggle d-flex align-items-center me-2">
                        <input
                          type="radio"
                          name="theme-mode"
                          id="light_mode"
                          className="check color-check stylemode lmode"
                          value="light_mode"
                          checked={layoutColor === "light_mode"}
                          onChange={LightThemes}
                        />
                        <label htmlFor="light_mode" className="checktoggles">
                          <ImageWithBasePath
                            src="assets/img/theme/theme-img-01.jpg"
                            alt="img"
                          />
                          <span className="theme-name">Light Mode</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-6 ere">
                  <div className="layout-wrap">
                    <div className="d-flex align-items-center">
                      <div className="status-toggle d-flex align-items-center me-2">
                        <input
                          type="radio"
                          name="theme-mode"
                          id="dark_mode"
                          className="check color-check stylemode"
                          value="dark_mode"
                          checked={layoutColor === "dark_mode"}
                          onChange={DarkThemes}
                        />
                        <label htmlFor="dark_mode" className="checktoggles">
                          <ImageWithBasePath
                            src="assets/img/theme/theme-img-02.jpg"
                            alt="img"
                          />
                          <span className="theme-name">Dark Mode</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="theme-mode border-0">
                <div className="theme-head">
                  <h6>Direction</h6>
                  <p>Select the direction for your app.</p>
                </div>
                <div className="row">
                  <div className="col-xl-6 ere">
                    <div className="layout-wrap">
                      <div className="d-flex align-items-center">
                        <div className="status-toggle d-flex align-items-center me-2">
                          <input
                            type="radio"
                            name="direction"
                            id="ltr"
                            className="check direction"
                            value="ltr"
                            checked={direction === "ltr"}
                            onChange={LTRDirection}
                          />
                          <label htmlFor="ltr" className="checktoggles">
                            <Link to="/">
                              <ImageWithBasePath
                                src="assets/img/theme/theme-img-01.jpg"
                                alt="img"
                              />
                            </Link>
                            <span className="theme-name">LTR</span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-6 ere">
                    <div className="layout-wrap">
                      <div className="d-flex align-items-center">
                        <div className="status-toggle d-flex align-items-center me-2">
                          <input
                            type="radio"
                            name="direction"
                            id="rtl"
                            className="check direction"
                            value="rtl"
                            checked={direction === "rtl"}
                            onChange={RTLDirection}
                          />
                          <label htmlFor="rtl" className="checktoggles">
                            <Link
                              to="https://dreamspos.dreamstechnologies.com/react/template-rtl/"
                              target="_blank"
                            >
                              <ImageWithBasePath
                                src="assets/img/theme/theme-img-03.jpg"
                                alt="img"
                              />
                            </Link>
                            <span className="theme-name">RTL</span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="theme-mode border-0 mb-0">
                  <div className="theme-head">
                    <h6>Layout Mode</h6>
                    <p>Select the primary layout style for your app.</p>
                  </div>
                  <div className="row">
                    <div className="col-xl-6 ere">
                      <div className="layout-wrap">
                        <div className="d-flex align-items-center">
                          <div className="status-toggle d-flex align-items-center me-2">
                            <input
                              type="radio"
                              name="layout"
                              id="default_layout"
                              className="check layout-mode"
                              value="default"
                              checked={layoutView === "default"}
                              onChange={DefaultStyle}
                            />
                            <label
                              htmlFor="default_layout"
                              className="checktoggles"
                            >
                              <ImageWithBasePath
                                src="assets/img/theme/theme-img-01.jpg"
                                alt="img"
                              />
                              <span className="theme-name">Default</span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-6 ere">
                      <div className="layout-wrap">
                        <div className="d-flex align-items-center">
                          <div className="status-toggle d-flex align-items-center me-2">
                            <input
                              type="radio"
                              name="layout"
                              id="box_layout"
                              className="check layout-mode"
                              value="box"
                              checked={layoutView === "box"}
                              onChange={LayoutBox}
                            />
                            <label
                              htmlFor="box_layout"
                              className="checktoggles"
                            >
                              <ImageWithBasePath
                                src="assets/img/theme/theme-img-07.jpg"
                                alt="img"
                              />
                              <span className="theme-name">Box</span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-6 ere">
                      <div className="layout-wrap">
                        <div className="d-flex align-items-center">
                          <div className="status-toggle d-flex align-items-center me-2">
                            <input
                              type="radio"
                              name="layout"
                              id="collapse_layout"
                              className="check layout-mode"
                              value="collapsed"
                              checked={layoutView === "collapsed"}
                              onChange={CollapsedLayout}
                            />
                            <label
                              htmlFor="collapse_layout"
                              className="checktoggles"
                            >
                              <ImageWithBasePath
                                src="assets/img/theme/theme-img-05.jpg"
                                alt="img"
                              />
                              <span className="theme-name">Collapsed</span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-6 ere">
                      <div className="layout-wrap">
                        <div className="d-flex align-items-center">
                          <div className="status-toggle d-flex align-items-center me-2">
                            <input
                              type="radio"
                              name="layout"
                              id="horizontal_layout"
                              className="check layout-mode"
                              value="horizontal"
                              checked={layoutView === "horizontal"}
                              onChange={HorizontalLayout}
                            />
                            <label
                              htmlFor="horizontal_layout"
                              className="checktoggles"
                            >
                              <ImageWithBasePath
                                src="assets/img/theme/theme-img-06.jpg"
                                alt="img"
                              />
                              <span className="theme-name">Horizontal</span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-6 ere">
                      <div className="layout-wrap">
                        <div className="d-flex align-items-center">
                          <div className="status-toggle d-flex align-items-center me-2">
                            <input
                              type="radio"
                              name="layout"
                              id="modern_layout"
                              className="check layout-mode"
                              value="modern"
                              checked={layoutView === "modern"}
                              onChange={ModernLayout}
                            />
                            <label
                              htmlFor="modern_layout"
                              className="checktoggles"
                            >
                              <ImageWithBasePath
                                src="assets/img/theme/theme-img-04.jpg"
                                alt="img"
                              />
                              <span className="theme-name">Modern</span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div id="nav_color">
                  <div className="theme-mode">
                    <div className="theme-head">
                      <h6>Navigation Colors</h6>
                      <p>Setup the color for the Navigation</p>
                    </div>
                    <div className="row">
                      <div className="col-xl-4 ere">
                        <div className="layout-wrap">
                          <div className="d-flex align-items-center">
                            <div className="status-toggle d-flex align-items-center me-2">
                              <input
                                type="radio"
                                name="nav_color"
                                id="light_color"
                                className="check nav-color"
                                value="light"
                                checked={layoutTheme === "light"}
                                onChange={LayoutLight}
                              />
                              <label
                                htmlFor="light_color"
                                className="checktoggles"
                              >
                                <span className="theme-name">Light</span>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-4 ere">
                        <div className="layout-wrap">
                          <div className="d-flex align-items-center">
                            <div className="status-toggle d-flex align-items-center me-2">
                              <input
                                type="radio"
                                name="nav_color"
                                id="grey_color"
                                className="check nav-color"
                                value="grey"
                                checked={layoutTheme === "grey"}
                                onChange={LayoutGrey}
                              />
                              <label
                                htmlFor="grey_color"
                                className="checktoggles"
                              >
                                <span className="theme-name">Grey</span>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-4 ere">
                        <div className="layout-wrap">
                          <div className="d-flex align-items-center">
                            <div className="status-toggle d-flex align-items-center me-2">
                              <input
                                type="radio"
                                name="nav_color"
                                id="dark_color"
                                className="check nav-color"
                                value="dark"
                                checked={layoutTheme === "dark"}
                                onChange={LayoutDark}
                              />
                              <label
                                htmlFor="dark_color"
                                className="checktoggles"
                              >
                                <span className="theme-name">Dark</span>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="sidebar-footer">
              <div className="row">
                <div className="col-xl-6">
                  <div className="footer-preview-btn">
                    <button
                      type="button"
                      className="btn btn-secondary w-100"
                      onClick={ResetData}
                    >
                      Reset
                    </button>
                  </div>
                </div>
                <div className="col-xl-6">
                  <div className="footer-reset-btn">
                    <Link to="#" className="btn btn-primary w-100">
                      Buy Now
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThemeSettings;